export default {
  "config": {
    "trial": "tones-3",
    "id": "summary",
    "type": "design",
    "title": "An Overview of the TONES 3 Study of Efficacy and Safety of Solriamfetol in Adults with Obstructive Sleep Apnea (OSA) and Excessive Daytime <no-break>Sleepiness (EDS)<sup>23,30</sup></no-break>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>"
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "tones-3",
    "id": "summary",
    "data-type": "design",
    "title": "An Overview of the TONES 3 Study of Efficacy and Safety of Solriamfetol in Adults with Obstructive Sleep Apnea (OSA) and Excessive Daytime <no-break>Sleepiness (EDS)<sup>23,30</sup></no-break>",
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-note1"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>"
  }
};